/**
 * @fileoverview This file contains the top contents of the website.
 */

import { Link } from "react-router-dom";
import { ContactLink } from "../components/ContactLink";
import { TableRow } from "../components/TableRow";
import LinkList from "../components/LinkList";

/**
 * Top contents
 * @returns {JSX.Element} トップページの JSX element
 */
export function TopContents(): JSX.Element {
  /**
   * トラブルシューティングの項目のリンクリスト
   */
  const items = [
    { to: "/cmcd-200/HelpAndSupport", text: "トラブルシューティングとQandA" },
  ];

  /**
   * ダウンロードの項目のリンクリスト
   */
  const downloadLinkList = [
    { to: "/cmcd-200/HowToDownload", text: "ダウンロード方法" },
    {
      to: "/cmcd-200/HowToInstallDeviceDriver",
      text: "デバイスドライバーのインストール方法",
    },
    { to: "/cmcd-200/HowToUse", text: "ロギングデータをパソコンで確認する" },
    { to: "/cmcd-200/Version", text: "バージョン情報" },
  ];

  /**
   * お知らせの項目のリンクリスト
   */
  const noticeList = [
    {
      to: "/cmcd-200/Windows11Supported",
      text: "Windows 11動作確認",
    },
    {
      to: "/cmcd-200/WindowsSupportEnd",
      text: "Windows Vista,7,8,8.1動作保証終了",
    },
  ];

  return (
    <div>
      <div className="c-section">
        <p className="c-text">
          一酸化炭素・二酸化炭素測定器
          CMCD-200のロギングデータをパソコンで確認するためのソフトウェアをダウンロードできます。
          下の「ダウンロードページへ」ボタンを押して、ソフトウェアをダウンロードし、
          ドライバーソフトウェアをインストールすると、CMCD-200のロギングデータをパソコンに取り込むことができます。
        </p>
      </div>

      <section className="c-section">
        <h2 className="p-heading-2">
          ダウンロード Ver1.0.0(Release 2015.02.03)
        </h2>
        {/** 上マージン制御用のユーティリティ .u-mt-xx を使用。common.css の288行目から314行目を参照*/}
        <div className="c-wrapper c-wrapper--close-btn u-mt-30">
          <Link
            to="/cmcd-200/Download"
            className="c-btn c-btn--default c-btn--block"
          >
            ダウンロードページへ
          </Link>
        </div>
        <LinkList items={downloadLinkList} />
      </section>

      <section className="c-section">
        <h2 className="p-heading-2">お知らせ</h2>
        <LinkList items={noticeList} />
        <p className="c-link-list">
          2015.02.03 CMCD-200ソフトウェアダウンロードページ開設
        </p>
      </section>

      <section className="c-section">
        <h2 className="p-heading-2">ソフトウェアのトラブルや疑問</h2>
        <LinkList items={items} />
      </section>

      <section className="c-section">
        <h2 className="p-heading-2" id="systemRequirements">
          動作環境
        </h2>
        <table className="c-table">
          <tbody>
            <TableRow label="OS" value="Windows 10, 11" />
            <TableRow label="インターフェース" value="USB2.0" />
          </tbody>
        </table>
      </section>

      <ContactLink />
    </div>
  );
}
